export enum PrescriptionStatus {
  OTC = 'OTC',
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
}
